import type { JSX } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { REFEREE_RELATIONSHIPS } from '@/shared/constants/referee-relationships';
import type { RefereeRelationship } from '../types/referee-app.types';

interface RelationshipSelectProps {
  value: RefereeRelationship | null | undefined;
  onChange: (value: RefereeRelationship) => void;
  disabled?: boolean;
}

export function RelationshipSelect({
  value,
  onChange,
  disabled,
}: RelationshipSelectProps): JSX.Element {
  return (
    <Select value={value ?? ''} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger>
        <SelectValue placeholder="Select relationship type" />
      </SelectTrigger>
      <SelectContent>
        {REFEREE_RELATIONSHIPS.map((rel) => (
          <SelectItem key={rel.value} value={rel.value}>
            {rel.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
